import { render, staticRenderFns } from "./AddJob.vue?vue&type=template&id=6616bfd8"
import script from "./AddJob.vue?vue&type=script&lang=ts"
export * from "./AddJob.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports